import React from 'react'
import {
  FormControl, FormControlLabel, FormGroup, FormLabel,
  Slider, Switch
} from '@mui/material'

const Sound = ({ form, change }) => {
  const changeSound = key => change.checked(value => ({ sound: { [key]: { $set: value } } }))

  return (
    <>
      <FormGroup className="form-group">
        <FormControl>
          <FormControlLabel
            control={
              <Switch color="primary"
                      checked={form.sound.chat}
                      onChange={changeSound('chat')} />
            }
            label="チャット音" />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group">
        <FormControl>
          <FormControlLabel
            control={
              <Switch color="primary"
                      checked={form.sound.roundwin}
                      onChange={changeSound('roundwin')} />
            }
            label="勝抜音" />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group">
        <FormControl>
          <FormControlLabel
            control={
              <Switch color="primary"
                      checked={form.sound.timeup}
                      onChange={changeSound('timeup')} />
            }
            label="タイマー終了音" />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group">
        <FormControl>
          <FormControlLabel
            control={
              <Switch color="primary"
                      checked={form.sound.open}
                      onChange={changeSound('open')} />
            }
            label="ボードオープン音" />
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-10">
        <FormControl>
          <FormLabel>音量</FormLabel>
          <Slider sx={{ ml: '10%', width: '80%' }} min={0} max={100}
                  valueLabelDisplay="auto"
                  marks={[{ value: 0, label: '0%' }, { value: 100, label: '100%' }]}
                  value={form.sound.volume}
                  onChange={change.value(value => ({ sound: { volume: { $set: value } } }))} />
        </FormControl>
      </FormGroup>
    </>
  )
}

export default Sound
